/* eslint-disable no-unused-vars */
export function paths(url) {
  const a = url.split('?')[0]
  var index = ''
  if (a == "#/") {
    index = 1;
  } else if (a == "#/invoice") {
    index = 2;
  } else if (a == "#/collectionPayment") {
    index = 3;
  } else if (a == "#/setTing") {
    index = 4;
  } else if (a == '#/setTing/download'){
    index = 4
  } else if (a == '#/prestore'){
    index = 5
  }
  return index
}
